import React from "react";
import CustomersAdmin from "./Customers-Admin";

const CustomersProfileManagement = () => {
  return <CustomersAdmin />;
};

export default CustomersProfileManagement;
